export const brandName = "吃瓜看料";

export const heroStats = [
  { label: "今日实时更新", value: "128", unit: "条" },
  { label: "正在前线围观", value: "3.2", unit: "万人" },
  { label: "深度爆料追踪", value: "46", unit: "篇" },
  { label: "话题覆盖板块", value: "6", unit: "个" },
];

export const tickerItems = [
  "音乐节压轴阵容临时调整，主办方深夜发文回应",
  "新一代折叠屏首销即售罄，线下排队画面刷屏",
  "城市夜市人气暴涨，摊主一晚接待上千人",
  "新能源品牌季度交付创新高，盘面出现异动",
  "秋冬首轮寒潮南下，多城提前开启集中供暖",
  "焦点战补时绝杀，看台欢呼声浪掀翻全场",
];

export const categories = [
  {
    id: "ent",
    name: "娱乐前线",
    icon: "ri-mic-line",
    desc: "演出现场、综艺动态、幕后花絮第一时间汇总，带你看懂台前幕后的真实节奏。",
    count: 42,
    samples: ["音乐节阵容调整始末", "综艺未播片段引二创", "演唱会退票风波追踪"],
  },
  {
    id: "society",
    name: "社会热点",
    icon: "ri-building-2-line",
    desc: "城市生活、公共事件、暖心瞬间的现场直击，用细节还原事件的完整脉络。",
    count: 35,
    samples: ["夜市人气背后的摊主日常", "拾金不昧后续暖心收尾", "暴雨应急响应实录"],
  },
  {
    id: "tech",
    name: "科技数码",
    icon: "ri-cpu-line",
    desc: "新机发布、系统更新、开源项目的实测与拆解，跑分之外更看真实体验。",
    count: 28,
    samples: ["折叠屏首销拆解", "开源大模型实测对比", "续航快充横评记录"],
  },
  {
    id: "finance",
    name: "财经观察",
    icon: "ri-line-chart-line",
    desc: "行情异动、消费趋势与理财新风向的通俗解读，帮普通读者看懂数字背后。",
    count: 21,
    samples: ["黄金热与攒金豆", "新能源交付解读", "消费券拉动效应观察"],
  },
  {
    id: "life",
    name: "生活万象",
    icon: "ri-leaf-line",
    desc: "天气、出行、居家与市井生活的实用资讯，跟你的日常贴得最近。",
    count: 33,
    samples: ["寒潮南下影响范围", "通勤路线调整提醒", "入秋囤货省钱指南"],
  },
  {
    id: "sports",
    name: "体育竞技",
    icon: "ri-basketball-line",
    desc: "赛况速递、焦点对决与球迷现场故事，输赢之外还有更多值得围观。",
    count: 19,
    samples: ["补时绝杀名场面", "客场球迷远征记", "青训营少年成长观察"],
  },
];

export const hotFeed = [
  {
    id: "f1",
    categoryId: "ent",
    category: "娱乐前线",
    time: "2分钟前",
    title: "某音乐节压轴阵容临时调整，主办方深夜发文回应",
    summary: "开演前六小时阵容名单出现变动，现场观众陆续收到推送，主办方称因设备检修进行调整并公布补偿方案。",
    heat: "986万",
    isLive: true,
  },
  {
    id: "f2",
    categoryId: "tech",
    category: "科技数码",
    time: "8分钟前",
    title: "新一代折叠屏首销即售罄，线下排队画面刷屏",
    summary: "多家线下门店提前排起长队，二手平台出现小幅溢价，铰链与重量成为讨论最多的两个关键词。",
    heat: "742万",
    isLive: true,
  },
  {
    id: "f3",
    categoryId: "society",
    category: "社会热点",
    time: "16分钟前",
    title: "城市夜市人气暴涨，摊主一晚接待上千人现场直击",
    summary: "老街区改造后迎来客流高峰，有摊主表示备货量翻了三倍，管理方同步加派了夜间疏导人员。",
    heat: "638万",
    isLive: false,
  },
  {
    id: "f4",
    categoryId: "finance",
    category: "财经观察",
    time: "24分钟前",
    title: "新能源品牌季度交付创新高，盘面出现明显异动",
    summary: "交付数据公布后相关板块快速拉升，机构研报聚焦产能爬坡与海外渠道两款增长曲线。",
    heat: "512万",
    isLive: false,
  },
  {
    id: "f5",
    categoryId: "life",
    category: "生活万象",
    time: "38分钟前",
    title: "秋冬首轮寒潮南下，多城提前开启集中供暖",
    summary: "气象部门提示昼夜温差拉大，多地供暖时间较往年提前，居家保暖用品搜索量明显上升。",
    heat: "447万",
    isLive: false,
  },
  {
    id: "f6",
    categoryId: "sports",
    category: "体育竞技",
    time: "52分钟前",
    title: "焦点战补时绝杀，看台欢呼声浪掀翻全场",
    summary: "比赛读秒阶段的进球改写比分，客队球迷区瞬间沸腾，赛后更衣室画面在网络快速传播。",
    heat: "398万",
    isLive: false,
  },
  {
    id: "f7",
    categoryId: "ent",
    category: "娱乐前线",
    time: "1小时前",
    title: "某综艺未播片段流出，嘉宾互动细节引发二创热潮",
    summary: "被剪掉的互动片段在不同平台反复传播，网友按时间线整理出完整脉络，相关话题持续攀升。",
    heat: "356万",
    isLive: false,
  },
  {
    id: "f8",
    categoryId: "tech",
    category: "科技数码",
    time: "1小时前",
    title: "开源大模型新版本发布，开发者连夜实测跑分对比",
    summary: "社区在两小时内完成多轮基准测试，长文本理解与推理速度成为讨论焦点，衍生工具同步上线。",
    heat: "329万",
    isLive: false,
  },
  {
    id: "f9",
    categoryId: "society",
    category: "社会热点",
    time: "2小时前",
    title: "地铁站拾金不昧事件后续，失主手写感谢信感动网友",
    summary: "值班人员归还失物的细节被完整记录，手写感谢信字迹工整，相关话题登上多地本地热搜。",
    heat: "287万",
    isLive: false,
  },
  {
    id: "f10",
    categoryId: "finance",
    category: "财经观察",
    time: "2小时前",
    title: "黄金价格连续走高，年轻人开始流行攒金豆",
    summary: "小克重金饰销量上扬，攒金豆成为新的储蓄话题，专家提醒注意工费与回收折价等细节。",
    heat: "251万",
    isLive: false,
  },
];

export const hotRanking = [
  { id: "r1", label: "音乐节阵容临时调整", trend: "up", heat: "986万" },
  { id: "r2", label: "折叠屏首销排队", trend: "up", heat: "742万" },
  { id: "r3", label: "夜市人气暴涨现场", trend: "up", heat: "638万" },
  { id: "r4", label: "新能源交付创新高", trend: "flat", heat: "512万" },
  { id: "r5", label: "首轮寒潮南下", trend: "up", heat: "447万" },
  { id: "r6", label: "补时绝杀名场面", trend: "down", heat: "398万" },
];

export const deepDives = [
  {
    id: "d1",
    category: "深·追踪",
    title: "一场音乐节背后的城市流量密码",
    excerpt: "从票务、交通到周边餐饮，一场大型演出如何带动整片城区的热度，我们把镜头对准了台前幕后。",
    author: "现场组 · 阿岩",
    readTime: "8 分钟阅读",
    updated: "今天 20:14",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20music%20festival%20stage%20at%20dusk%20with%20warm%20coral%20stage%20lights%20and%20abstract%20crowd%20silhouettes%2C%20editorial%20magazine%20illustration%20style%2C%20cream%20and%20amber%20tone%2C%20grainy%20texture%2C%20cinematic%20composition&width=900&height=640&seq=cgk-deep-01&orientation=landscape",
    body: [
      "大型演出往往不只是舞台上的几个小时。从官宣阵容到散场收尾，一条完整的城市服务链被同时激活，交通、住宿、餐饮与周边零售在短时间内迎来集中客流。",
      "我们沿着观众动线走了一遍：入场前的临时摆渡车、场外排起长队的小吃摊、散场后仍在疏导的工作人员。每一个环节都在说明，热度并非凭空出现，而是被一整套细致的准备托了起来。",
      "对本地商户来说，这种集中客流既是机会也是考验。备货、人手、动线规划都需要提前预判，稍有疏忽就会在高峰期掉链子。",
      "热度终会回落，但经验会被留下。把一次演出的应对流程沉淀成可复用的方案，才是城市真正拿到手的长期资产。",
    ],
  },
  {
    id: "d2",
    category: "深·拆解",
    title: "折叠屏为何突然卖爆？供应链视角全拆解",
    excerpt: "铰链、屏幕与电池三项核心指标同步改善，价格下探到新区间，消费者终于愿意为折叠形态买单。",
    author: "数码组 · 白桃",
    readTime: "6 分钟阅读",
    updated: "今天 18:02",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20exploded%20view%20of%20a%20folding%20smartphone%20component%20diagram%20on%20graphic%20grid%2C%20clean%20technical%20illustration%2C%20jade%20green%20and%20cream%20palette%2C%20soft%20studio%20lighting%2C%20editorial%20tech%20feature%20visual&width=900&height=640&seq=cgk-deep-02&orientation=landscape",
    body: [
      "折叠形态曾长期卡在「厚重、折痕、昂贵」三道门槛上。今年多条供应链同步迭代，让这三道门槛同时出现了松动。",
      "铰链结构的零件数量下降，良率随之提升；超薄玻璃的弯折寿命明显延长；电池能量密度上探后，机身可以做得更轻薄而不用牺牲续航。",
      "更关键的是价格。当主流机型落到消费者愿意尝试的区间，观望人群就会转化为实际购买，首销排队正是这一转变的直接体现。",
      "当然，折叠屏离「彻底普及」还有距离。维修成本、配件生态与应用适配仍需要时间，但从这一代开始，方向已经足够清晰。",
    ],
  },
  {
    id: "d3",
    category: "深·直击",
    title: "夜经济升温，摊主们的真实一天",
    excerpt: "从下午三点备货到凌晨收摊，我们跟着三位摊主完整走完了一天，记录下热闹背后的耐心与计算。",
    author: "生活组 · 小满",
    readTime: "7 分钟阅读",
    updated: "今天 16:40",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20night%20market%20street%20scene%20with%20warm%20hanging%20lanterns%20and%20abstract%20food%20stalls%2C%20editorial%20illustration%20style%2C%20amber%20and%20coral%20glow%2C%20soft%20grain%2C%20warm%20inviting%20atmosphere&width=900&height=640&seq=cgk-deep-03&orientation=landscape",
    body: [
      "夜市的热闹通常只被看见最沸腾的那几个小时，但摊主的一天，从下午就要开始。",
      "备货是第一道功课。什么品类走得快、哪些当天必须清掉、天气会不会影响客流，都要在出门前算一遍。",
      "傍晚六点后客流进入高峰，出餐、收银、补货几乎同时进行。一个熟练的摊位，靠的是把动线理顺、把工具放在顺手的位置。",
      "凌晨收摊时，摊主们聊得最多的是「明天备多少」。热闹属于夜晚，而支撑热闹的，是日复一日的经验和耐心。",
    ],
  },
  {
    id: "d4",
    category: "深·复盘",
    title: "黄金热背后，年轻人的新理财观",
    excerpt: "当金价持续走高，攒金豆从小众玩法变成大众话题。我们聊聊这股热潮里的真实动机与隐藏成本。",
    author: "财经组 · 老周",
    readTime: "5 分钟阅读",
    updated: "今天 14:26",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20arrangement%20of%20small%20gold%20beads%20and%20minimal%20coins%20on%20soft%20cream%20surface%2C%20editorial%20still%20life%20illustration%2C%20warm%20golden%20light%2C%20clean%20elegant%20composition%2C%20magazine%20feature%20visual&width=900&height=640&seq=cgk-deep-04&orientation=landscape",
    body: [
      "攒金豆的走红，与其说是投资行为，不如说是一种更容易坚持的储蓄方式。小克重、低门槛、看得见，这三点恰好击中了年轻人的心理。",
      "但便宜不等于没有成本。工费、品牌溢价与回收折价，都会影响最终的收益率，把这三项算清楚，才知道自己买到的到底是什么。",
      "从资产配置的角度看，把全部闲钱押在单一品类上并不明智。黄金更适合作为组合里的一小块，用来分散而不是用来暴富。",
      "热潮会退去，习惯会留下。比起追逐价格，建立一套能长期执行的储蓄纪律，或许是这轮黄金热给年轻人最实在的提醒。",
    ],
  },
];

export const buzzList = [
  {
    id: "b1",
    nick: "蹲瓜第一线",
    avatar: "https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20curious%20young%20person%20with%20coral%20background%2C%20clean%20geometric%20style%2C%20no%20text%2C%20simple%20shapes&width=200&height=200&seq=cgk-ava-01&orientation=squarish",
    text: "蹲了一整晚终于等到官方回应，评论区已经建了三百层楼，脉络整理得比我想象中还清楚。",
    topic: "音乐节阵容调整",
    likes: 3286,
  },
  {
    id: "b2",
    nick: "数码不求人",
    avatar: "https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20tech%20enthusiast%20with%20jade%20green%20background%2C%20clean%20geometric%20style%2C%20no%20text%2C%20simple%20shapes&width=200&height=200&seq=cgk-ava-02&orientation=squarish",
    text: "首销那天的排队图我是真没想到，折叠屏这次轻了不少，线下摸过之后确实心动了。",
    topic: "折叠屏首销",
    likes: 2741,
  },
  {
    id: "b3",
    nick: "夜宵摊常客",
    avatar: "https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20cheerful%20food%20lover%20with%20amber%20background%2C%20clean%20geometric%20style%2C%20no%20text%2C%20simple%20shapes&width=200&height=200&seq=cgk-ava-03&orientation=squarish",
    text: "上周刚去过那条夜市，人气是真的旺。看完摊主一天的记录，才知道热闹背后有多费心思。",
    topic: "夜市人气暴涨",
    likes: 1998,
  },
  {
    id: "b4",
    nick: "会算账的小林",
    avatar: "https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20calm%20analytical%20person%20with%20cream%20and%20coral%20background%2C%20clean%20geometric%20style%2C%20no%20text%2C%20simple%20shapes&width=200&height=200&seq=cgk-ava-04&orientation=squarish",
    text: "攒金豆我坚持了半年，看完这篇把工费和回收价算了一遍，才发现之前想得太简单了。",
    topic: "黄金热与攒金豆",
    likes: 1653,
  },
  {
    id: "b5",
    nick: "看台记录员",
    avatar: "https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20an%20excited%20sports%20fan%20with%20teal%20background%2C%20clean%20geometric%20style%2C%20no%20text%2C%20simple%20shapes&width=200&height=200&seq=cgk-ava-05&orientation=squarish",
    text: "补时那脚球直接把我从座位上弹起来了，现场声浪现在还在耳边回响，值回票价。",
    topic: "补时绝杀名场面",
    likes: 1432,
  },
  {
    id: "b6",
    nick: "城市漫游者",
    avatar: "https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20friendly%20city%20walker%20with%20warm%20yellow%20background%2C%20clean%20geometric%20style%2C%20no%20text%2C%20simple%20shapes&width=200&height=200&seq=cgk-ava-06&orientation=squarish",
    text: "拾金不昧那封手写感谢信看得心里暖暖的，这种小事被认真对待的样子真好。",
    topic: "手写感谢信后续",
    likes: 1287,
  },
];

export const faqs = [
  {
    q: "吃瓜看料的内容多久更新一次？",
    a: "实时前线板块全天候滚动更新，热门事件出现新进展时会第一时间补位；深度爆料栏目通常每天整理数篇，按事件进展持续修订，页面会标注最近更新时间。",
  },
  {
    q: "网站上的爆料信息可靠吗？",
    a: "我们坚持多来源交叉核对，优先采用可公开查证的信息，并明确标注「已确认」与「待核实」。对于尚未坐实的说法，会以审慎措辞呈现，避免误导读者。",
  },
  {
    q: "我可以投稿爆料或提供线索吗？",
    a: "欢迎。你可以通过页面底部的联系邮箱把线索发给我们，尽量附上时间、地点与可验证的佐证材料。编辑会在核实后决定是否跟进，并保护线索提供者的隐私。",
  },
  {
    q: "如何第一时间收到热点提醒？",
    a: "把吃瓜看料加入浏览器书签并开启页面推送权限，热门事件跟进时会实时更新；你也可以关注实时前线板块，热点一上量就会出现在信息流顶部。",
  },
  {
    q: "内容会标注信息来源吗？",
    a: "会。每篇深度爆料都会说明主要信息来源与整理时间，涉及数据的部分尽量给出原始出处，方便你自行复核，而不是只看到结论。",
  },
  {
    q: "网站内容会涉及侵权或隐私问题吗？",
    a: "我们遵循最小必要的原则，聚焦公共事件本身，避免传播与事件无关的个人隐私。如你认为某条内容存在问题，可通过联系邮箱提出，我们会在核实后及时处理。",
  },
];

export const aboutValues = [
  {
    icon: "ri-focus-3-line",
    title: "现场优先",
    desc: "能到现场就不到转发区。第一手观察、第一手画面，是我们判断事件轻重的起点。",
  },
  {
    icon: "ri-shield-check-line",
    title: "核实居中",
    desc: "热度再高也先过一遍事实。未坐实的说法标注清楚，让读者自己判断，而不是替读者下结论。",
  },
  {
    icon: "ri-route-line",
    title: "脉络清晰",
    desc: "把一个热点按时间线、来源与关键节点整理明白，让三分钟翻阅也能掌握事件全貌。",
  },
  {
    icon: "ri-heart-3-line",
    title: "尊重当事人",
    desc: "围观不等于越界。与公共事件无关的隐私，我们不做二次传播，也不做标题党式的放大。",
  },
];

export const testimonials = [
  {
    name: "每天通勤刷一刷",
    role: "上班族 · 广州",
    quote: "时间线整理得特别清楚，十分钟就能把一个热点从头到尾看明白，省了我到处翻的时间。",
  },
  {
    name: "做内容的小同桌",
    role: "自媒体创作者 · 成都",
    quote: "找选题的灵感来源，深度爆料的复盘角度很实用，还能直接看到信息的出处。",
  },
  {
    name: "爱较真的观察者",
    role: "高校学生 · 南京",
    quote: "会区分「已确认」和「待核实」，这点很难得，读起来踏实，不会被人带着跑。",
  },
];

export const contactInfo = {
  email: "contact@chiguakanliao.com",
  business: "press@chiguakanliao.com",
  slogan: "现场直击 · 实时速递 · 全网热点前线围观",
};